import React, { useState, useEffect } from "react"
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from "reactstrap"
import Datatables from "components/Datatables/datatable"
import Select from "react-select"
import { PAYROLL_SSF_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const SSF = () => {
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [dataRows, setDataRows] = useState({ rows: [], total_rows: 0 })
    
    const [formData, setFormData] = useState({
        title: "",
        value: "",
        type: "Percentage"
    })

    const toggleModal = () => {
        if (modal) {
            setFormData({ title: "", value: "", type: "Percentage" })
            setIsEdit(false)
        }
        setModal(!modal)
    }

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(PAYROLL_SSF_URL)
        if (res.status === 200) {
            setDataRows(res.response)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = isEdit 
            ? await post(`${PAYROLL_SSF_URL}_update`, formData)
            : await post(PAYROLL_SSF_URL, formData)
            
        if (res.status === 200 || res.status === true) {
            Notifications("success", res.message)
            toggleModal()
            getData()
        } else {
            Notifications("error", res.message)
        }
    }

    const handleEdit = (row) => {
        setFormData({ ...row })
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this SSF record?")) {
            const res = await get(`${PAYROLL_SSF_URL}_delete?id=${id}`)
            if (res.status === 200 || res.status === true) {
                Notifications("success", res.message)
                getData()
            } else {
                Notifications("error", res.message)
            }
        }
    }

    const columns = [
        { dataField: "id", text: "#" },
        { dataField: "title", text: "TITLE" },
        { dataField: "value", text: "VALUE" },
        { dataField: "type", text: "TYPE" },
        {
            dataField: "status",
            text: "STATUS",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell == 1} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" onClick={() => handleDelete(row.id)}><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    return (
        <React.Fragment>
            <Datatables 
                title="SSF Management"
                titleClass="h5"
                columns={columns} 
                rows={dataRows.rows} 
                keyField="id" 
                isSearch={false} 
                isAdd={true} 
                btnTitle="Add SSF"
                btnColor="success"
                handleAddButton={toggleModal}
                loading={isLoading} 
            />

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{isEdit ? "Edit" : "Add"} SSF</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Title <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter title" 
                                        value={formData.title}
                                        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Type <span className="text-danger">*</span></Label>
                                    <Select 
                                        options={[{ label: "Percentage", value: "Percentage" }, { label: "Fixed", value: "Fixed" }]} 
                                        value={{ label: formData.type, value: formData.type }}
                                        onChange={(opt) => setFormData({ ...formData, type: opt.value })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Value <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="number" 
                                        placeholder="Enter value" 
                                        value={formData.value}
                                        onChange={(e) => setFormData({ ...formData, value: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Button style={brownBtnStyle} type="submit">{isEdit ? "Update" : "Create"}</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default SSF
